<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to delete <b>{{ section.name.toUpperCase() }}</b> section? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"  
          class="px-10 white--text"        
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      section: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.hrisSections().delete(this.section.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })
            }
          })
          .catch(error => {
            if (error.response.status === 405 || error.response.status === 500) {
              this.$snack({ 
                color: 'error',
                message: error.response.data.status, 
              })
            }
          })
          .then(() => {
            this.menu = false
            this.progressing = false
          })    
      },
    },
  }
</script>
